import { TeamSettingsLayout } from '../../components/TeamSettingsLayout';
import { TeamAccessCard } from '../../components/TeamAccessCard/TeamAccessCard';

export const TeamAccessManagement = () => (
  <TeamSettingsLayout>
    <TeamAccessCard />
  </TeamSettingsLayout>
);
